import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import LpgContinueSolid from "@/icons/Lpg/ContinueSolid";
import { ReactDefaultPropsWithChildren } from "../../types/react";
import { TextLink } from "../TextLink";
import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";

import styles from "./TileImageTeaser.scss";

type TileImageTeaserTileTextLinkBaseProps = {
  href?: string;
  customClass?: string;
};

export type TileImageTeaserTileTextLinkProps = TileImageTeaserTileTextLinkBaseProps &
  Omit<
    React.ComponentPropsWithoutRef<"a">,
    keyof TileImageTeaserTileTextLinkBaseProps
  >;

const defaultProps = {
  href: "#",
  children: undefined,
  customClass: undefined,
} as const;

const validatedDefaultProps: ReactDefaultPropsWithChildren<
  TileImageTeaserTileTextLinkBaseProps,
  typeof defaultProps
> = defaultProps;

const propTypes = {
  href: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  customClass: PropTypes.string,
} as const;

export const TileImageTeaserTileTextLink = ({
  children,
  customClass,
  href,
  ...restProps
}: TileImageTeaserTileTextLinkProps): JSX.Element => {
  return (
    <EqualHeightElement
      name="TileImageTeaserTileTextLink"
      className={styles["textlink-wrapper"]}
    >
      <TextLink
        href={href}
        variants={TextLink.Variant.highlight}
        iconRight={LpgContinueSolid}
        rightIconProps={{
          style: { position: "absolute", top: 2, left: 2 },
        }}
        customClass={cx(styles.textlink, customClass)}
        {...restProps}
      >
        {children}
      </TextLink>
    </EqualHeightElement>
  );
};

TileImageTeaserTileTextLink.propTypes = propTypes;
TileImageTeaserTileTextLink.defaultProps = validatedDefaultProps;

TileImageTeaserTileTextLink.displayName = "TileImageTeaser.Tile.TextLink";

export default TileImageTeaserTileTextLink;
